<template>
  <div class="paymoney">
    <el-dialog title="支付给讲师" :visible.sync="payDialogVisible" width="30%" @close="upload">
      <div class="money">
        <p class="num tc ">￥{{teacher_info.reward}}</p>
        <div class="title mt20">
          <span class="label iblock">讲师昵称：</span>
          <el-select
            class="name"
            v-model="guest_id"
            filterable
            clearable
            @change="seachStatus"
            placeholder="请选择讲师昵称"
          >
            <el-option
              v-for="(i,index) in guestList"
              :key="index"
              :label="i.guest_name"
              :value="i.user_id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="tc">
        <el-button @click="payDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()" :disabled="payStatus">支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { _guestsList } from "@/api/guest-setting.js";
//支付给讲师
import { _payToTeacher } from "@/api/order.js";

export default {
  data() {
    return {
      payDialogVisible: false,
      guest_id: "",
      guestList:[],
      teacher_info: {}
    };
  },
  props: {
    respondVisible: {
      type: Boolean,
      default: false
    },
    resmessage: {
      type: Object,
      default: {}
    }
  },
  computed: {
    payStatus() {
      if (this.guest_id !== "") {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    respondVisible(val) {
      this.payDialogVisible = val;
    },
    //传递的讲师信息
    resmessage(val) {
      console.log(val);
      this.teacher_info = val;
      this.InitGuestsList(val.course_id);
    }
  },
  methods: {
    submit() {
      // this.$emit("uploadInfo", true);
      // this.$emit("update:respondVisible", false);
      this.payToTeacher();
    },
    //支付接口
    payToTeacher(){
      _payToTeacher({
        params:{
          course_id:this.teacher_info.course_id,
          user_id:this.guest_id
        }
      }).then(res=>{
        if(res.resultCode==1){
          this.$message.success(res.errorMsg);
          this.$emit("uploadInfo", true);
          // this.$emit("update:respondVisible", false);
        }else{
          this.$message.error(res.errorMsg);
        }
      })
    },
    upload() {
      this.$emit("update:respondVisible", false);
      this.guest_id='';
    },
    seachStatus(val) {
      console.log(val);
    },
    //获取课程对应的嘉宾列表（）也就是讲师列表
      InitGuestsList(id){
      _guestsList({
        params: {
          course_id: id,
        }
      }).then(res => {
        if(res.resultCode==1){
          this.guestList=res.result;
        }else{
          this.$message.error(res.errorMsg);
        }
      });
    },
  }
};
</script>


<style lang="less" scoped>
.money {
    .title{
        display: flex;
        align-items: center;
        .label{
            width: 100px;
        }
        .name{
            flex:1;
        }
    }
  .num {
    font-size: 26px;
    font-weight: 600;
  }
}
</style>